import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../cn';

const SIZE_CLASSES = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12'
};

const COLOR_CLASSES = {
  primary: 'text-primary-500',
  white: 'text-white',
  gray: 'text-gray-500'
};

const Spinner = ({
  size = 'md',
  color = 'primary',
  className = '',
  label = 'Loading',
  ...props
}) => (
  <svg
    className={cn('animate-spin', SIZE_CLASSES[size], COLOR_CLASSES[color], className)}
    fill="none"
    viewBox="0 0 24 24"
    role="status"
    aria-label={label}
    {...props}
  >
    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

Spinner.displayName = 'Spinner';

Spinner.propTypes = {
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  color: PropTypes.oneOf(['primary', 'white', 'gray']),
  className: PropTypes.string,
  label: PropTypes.string
};

export default Spinner;
